import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LinkedOutcomeList } from '../types/linked-outcome-tree';
import { ProjectLinkedOutcomeModel } from '../../../../../../hub_schema/hubTypes';

@Component({
  selector: 'app-linked-outcome-table',
  templateUrl: './linked-outcome-table.component.html',
  styleUrl: './linked-outcome-table.component.scss',
  standalone: false
})
export class LinkedOutcomeTableComponent {

    @Input()
    public linkedOutcomeList: LinkedOutcomeList;

    @Output()
    public removeLinkRequested: EventEmitter<ProjectLinkedOutcomeModel> = new EventEmitter<ProjectLinkedOutcomeModel>();

    public removeLink(linkedOutcome: ProjectLinkedOutcomeModel): void {
        this.removeLinkRequested.emit(linkedOutcome);
    }

}
